import React, { Fragment , useContext } from 'react'
import { func } from 'prop-types'

import { Tabs, TabPanel, Row, Col } from '@paypalcorp/pp-react'
import { Context as WorldReadyContext } from "@paypalcorp/worldready-react";
import { MessageFormat } from "@paypalcorp/worldready";
import { fptiCustomClick, serverData } from '../../utils'
import { Sections } from '../../components'
import {
  privacySections,
  dataPlatformSections,
  secondaryHeader,
} from '../../config'

const PRIVACY_LINK_INDEX = 2

const SubHeader = ({ onSectionClick }) => {
  const worldReady = useContext(WorldReadyContext);

  const handleHeaderLinksClick = (event, tabIdxClicked) => {
    fptiCustomClick(secondaryHeader[tabIdxClicked].fptiClickData)
    window.location.href = secondaryHeader[tabIdxClicked].link
  }

  const tempFilteredHeader = secondaryHeader.map(headerElement=>{
    return {...headerElement, label : new MessageFormat(worldReady, { id: headerElement.label }).format()}
  })
  const filteredHeader =tempFilteredHeader.filter(
    (header) =>
      header.hasElmoTreatment === undefined || header.hasElmoTreatment === true,
  )

  const renderTabPanels = () =>
    filteredHeader.map(({ id, panelId, containerClass }) => (
      <TabPanel id={panelId} key={id} className={containerClass}>
        {id === 'privacyLink' && (
          <Fragment>
            <Sections
              sections={privacySections}
              onSectionClick={onSectionClick}
            />
            <Sections
              sections={dataPlatformSections}
              onSectionClick={onSectionClick}
            />
          </Fragment>
        )}
      </TabPanel>
    ))

  return (
    <Row className="one-section-only">
      <Col md={{ span: 12 }}>
        {serverData.isNative || serverData.isMerchantUser ? (
          <Fragment>
            <Sections
              sections={privacySections}
              onSectionClick={onSectionClick}
            />
            <Sections
              sections={dataPlatformSections}
              onSectionClick={onSectionClick}
            />
          </Fragment>
        ) : (
          <Tabs
            name="SecondaryHeaderLinks"
            selectedTabIdx={PRIVACY_LINK_INDEX}
            tabs={filteredHeader}
            onClick={handleHeaderLinksClick}
            tabClassName="subHeader-tab"
          >
            {renderTabPanels()}
          </Tabs>
        )}
      </Col>
    </Row>
  )
}

SubHeader.propTypes = {
  onSectionClick: func.isRequired,
}

export default SubHeader
